class OptionGuideModal extends HTMLElement {
    isOpen = false;
    swiper = null;
    dialog = null;
  
    constructor() {
      super();
      this.init();
    }
  
    init() {
      this.dialog = this.querySelector("dialog");
      if (this.dialog) {
        this.dialog.addEventListener("click", (e) => {
          const dialogDimensions = this.dialog.getBoundingClientRect();
          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
            dialog.close();
          }
        });
      }
    }
    show() {
      if (this.dialog) {
        this.dialog.showModal();
        this.dialog.querySelectorAll("photo-swiper").forEach((el) => {
          if (
            el.style.display !== "none" &&
            typeof el.initSwiper === "function"
          ) {
            el.initSwiper();
          }
        });
      }
    }
  }
  
  if (!customElements.get("option-guide-modal")) {
    customElements.define("option-guide-modal", OptionGuideModal);
  }
  